import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { SignalShortInfoType } from '../../utils/transform-response';
type ValidationTimelineItemBodyProps = {
  signals: SignalShortInfoType[];
};
const ValidationTimelineItemBody = t0 => {
  const $ = _c(10);
  const {
    signals
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.onboardingDecisionEvent.notVerifiedDetails.fieldValidations"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = level => {
      const levelMap = {
        exact: () => t(_temp),
        no_match: () => t(_temp2),
        could_not_match: () => t(_temp3),
        partial: () => t(_temp4),
        verified: () => t(_temp5),
        not_verified: () => t(_temp6)
      };
      return levelMap[level]?.() || level;
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getMatchLevelLabel = t2;
  let t3;
  if ($[3] !== getMatchLevelLabel || $[4] !== signals) {
    let t4;
    if ($[6] !== getMatchLevelLabel) {
      t4 = (t5, i) => {
        const {
          matchLevel,
          description,
          reasonCode
        } = t5;
        const key = `${reasonCode}-${i}`;
        return <div key={key} className="flex flex-row items-start gap-1"><p className="text-secondary"><span className="text-label-2 text-secondary nowrap">{`${getMatchLevelLabel(matchLevel)}:`}</span><span className="pl-1 text-body-2 text-tertiary">{description}</span></p></div>;
      };
      $[6] = getMatchLevelLabel;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = signals.map(t4);
    $[3] = getMatchLevelLabel;
    $[4] = signals;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <>{t3}</>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ValidationTimelineItemBody;
function _temp($) {
  return $.matchLevel.exact;
}
function _temp2($_0) {
  return $_0.matchLevel.no_match;
}
function _temp3($_1) {
  return $_1.matchLevel.could_not_match;
}
function _temp4($_2) {
  return $_2.matchLevel.partial;
}
function _temp5($_3) {
  return $_3.matchLevel.verified;
}
function _temp6($_4) {
  return $_4.matchLevel.not_verified;
}